import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'
import Dashboard from '../views/DashboardView.vue'
import appLayout from '../layouts/AppLayout.vue'
import defaultLayout from '../layouts/DefaultLayout.vue'
import configuration from './configuration'
import user from './user'
import product from './product'
import booking from './booking'
import hotelsJuniper from './hotelsJuniper'
import ticketsKudenix from './ticketsKudenix'
import transferKudenix from './tranferKudenix'
import hotelsKudenix from './hotelsKudenix'
import hotelsRestel from './hotelsRestel'
import ticketsHotelbeds from './ticketsHotelbeds'
import markups from './markups'
import place from './place'
import superadmin from './superadmin'
import flightSantsg from './flightSantsg'
import whitelabels from './whitelabels'
import hotelsRatehawk from './hotelsRatehawk'
import insuranceKudenix from './insuranceKudenix'

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: '/',
      name: 'home',
      component: HomeView,
      meta: { layout: defaultLayout }
    },
    {
      path: '/logout',
      name: 'logout',
      component: () => import('../views/LogoutView.vue'),
      meta: { layout: defaultLayout }
    },
    {
      path: '/request-password',
      name: 'request-password',
      component: () => import('../views/RememberPasswordView.vue'),
      meta: { layout: defaultLayout }
    },
    {
      path: '/remember-password',
      name: 'change-password',
      component: () => import('../views/ChangePasswordView.vue'),
      meta: { layout: defaultLayout }
    },
    {
      path: '/dashboard',
      name: 'dashboard',
      component: Dashboard,
      meta: { layout: appLayout }
    },
    {
      path: '/about',
      name: 'about',
      // route level code-splitting
      // this generates a separate chunk (About.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import('../views/AboutView.vue'),
      meta: { layout: appLayout }
    },
    {
      path: '/piloto-mapa',
      name: 'piloto-mapa',
      component: () => import('../views/MapPilotView.vue'),
      meta: { layout: appLayout }
    },
    ...configuration,
    ...user,
    ...booking,
    ...product,
    ...hotelsJuniper,
    ...markups,
    ...ticketsKudenix,
    ...hotelsKudenix,
    ...transferKudenix,
    ...place,
    ...superadmin,
    ...hotelsRestel,
    ...ticketsHotelbeds,
    ...flightSantsg,
    ...whitelabels,
    ...insuranceKudenix,
    ...hotelsRatehawk,
  ]
})

export default router
